<template>
  <div class="moa-page-m">
    <div class="moa-page-m-header">
      <img alt="logo" style="height: 50%" src="@/assets/MOA_logo.png" />
      <mtd-icon v-if="isLogin" style="color: #1f2329; font-size: 6.4vw" @click="expand = !expand" type="secondary" :name="expand ? 'close' : 'menus-o'" />
      <mtd-button type="text-primary" @click="login" v-else>登录</mtd-button>
    </div>
    <div v-show="expand" class="moa-page-m-menu">
      <a href="https://agent-repair-prompt.sankuai.com/#/templateHtml?index=3-1-3" target="_blank"> 帮助文档 </a>
      <a href="https://x.sankuai.com/chat/19775?type=pubchat" target="_blank"> 6000帮助台 </a>
      <a href="mailto:moa.support@meituan.com" target="_blank">moa.support@meituan.com</a>
    </div>
    <div class="moa-page-m-content">
      <section>
        <div class="moa-logo-wrapper">
          <img class="moa-qrcode" src="@/assets/logo.png" />
        </div>
        <div class="moa-page-m-content-title">MOA 美团办公终端安全管理软件</div>
        <div class="moa-page-m-content-intro">面向美团生态体系下的用户，多角度维护终端安全，实现内网准入</div>
        <template v-if="isLogin">
          <div v-if="device === 'ios'">
            <mtd-button size="large" type="primary" @click="downloadIos">下载 iOS & iPadOS 客户端</mtd-button>
          </div>
          <div v-else>
            <mtd-button size="large" type="primary" @click="downloadAndroid">下载 Android 客户端</mtd-button>
          </div>
        </template>
        <mtd-button v-else size="large" type="primary" @click="login">登录后下载</mtd-button>
        <div class="version-tips" style="margin-top: 12px;">仅用于特殊场景入网</div>
        <div class="version-tips">{{ device === 'ios' ? '支持系统iOS 11-17' : '支持系统Android 5-14' }}</div>
        <div class="version-tips" v-if="device !== 'ios'">部分设备暂不支持，请<a href="https://x.sankuai.com/chat/19775" target="_blank">联系6000</a></div>
      </section>
    </div>
    <div class="moa-page-m-text" style="text-align: center; margin-top: 2vw; margin-bottom: 2vw">
      <div>不仅是办公的百宝箱，更是安全的守护门</div>
      <div>企业IT服务+安全服务，带给您更好的安全办公体验</div>
    </div>
    <div class="moa-page-m-text" style="min-height: 200px; font-size: 0">
      <img src="@/assets/img1_m.png" style="width: 100%" />
      <img src="@/assets/img2_m.png" style="width: 100%" />
      <img src="@/assets/img3_m.png" style="width: 100%" />
    </div>
    <div class="moa-page-m-text" style="text-align: center; margin-top: 6vw; margin-bottom: 2vw">
      <div>美团办公终端安全管理软件</div>
      <div>带给你更好的安全办公体验</div>
    </div>
    <div class="moa-page-o-copyright">MOA由美团信息安全部维护</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expand: false,
      androidUrl: '',
      iosUrl: '',
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.get_login_user.mis_id ? true : false;
    },
    device() {
      const ua = navigator.userAgent;
      if (/(iPhone|iPad|iPod|iOS|Macintosh|Mac)/i.test(ua)) {
        return 'ios';
      } else if (/(Android|Adr)/i.test(ua)) {
        return 'android';
      }
      return 'ios';
    },
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
    downloadAndroid() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.$store.dispatch('api_get_AndroidFile').then(res => {
          window.location.href = res.data;
        });
      } else {
        this.login();
      }
    },
    downloadIos() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.$store.dispatch('api_get_IosFile').then(res => {
          window.location.href = res.data;
        });
      } else {
        this.login();
      }
    }
  }
};
</script>

<style scoped>
.moa-page-m {
  position: relative;
  height: 100vh;
  overflow-y: auto;
  background: #fff;
}
.moa-page-m-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 11;
  height: 12vw;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0 5vw;
  margin: 0 auto;
  position: sticky;
  top: 0;
}
.moa-page-m-menu {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 12vw);
  background: #fff;
  overflow-x: hidden;
  overflow-y: overlay;
}
.moa-page-m-menu a {
  color: rgba(0, 0, 0, 0.84);
  padding: 0 5.2vw;
  display: block;
  font-size: 4.3vw;
  height: 12.8vw;
  line-height: 12.8vw;
  margin: 0;
  opacity: 1;
  padding: 0 6.4vw;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.moa-page-m-content {
  text-align: center;
  padding: 0 5vw;
  background: url(~@/assets/bg1.png) no-repeat;
  background-size: contain;
}
.moa-page-m-content-title {
  font-family: meituantype-Regular, 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Tahoma, Arial;
  color: #000;
  color: #1f2329;
  font-size: 5.4vw;
  font-weight: 700;
  line-height: 8.5vw;
  margin-bottom: 3.2vw;
}
.moa-page-m-content-intro {
  color: #51565d;
  font-size: 4.2vw;
  line-height: 6.4vw;
  margin-bottom: 6.4vw;
}

.moa-qrcode {
  width: calc(264vw / 7.5);
  height: auto;
}

.moa-logo-wrapper {
  text-align: center;
  padding-top: calc(80vw / 7.5);
  padding-bottom: calc(40vw / 7.5);
}

.moa-page-m-view {
  display: flex;
  padding: 5vw;
  justify-content: space-between;
}

.moa-page-m-view > div {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  text-align: left;
}

.moa-page-m-view img {
  width: 100%;
  height: auto;
}

.moa-page-m-text > div {
  padding: 2px 0;
}

.moa-page-m-text > div:first-child {
  font-weight: 500;
  font-size: 3.6vw;
}

.moa-page-m-text > div:nth-child(2) {
  font-weight: 500;
  font-size: 3vw;
}

.moa-page-m-text > div:last-child {
  font-weight: 400;
  font-size: 3vw;
}

.moa-page-o-copyright {
  height: 32px;
  line-height: 32px;
  background: rgb(59, 63, 72);
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #efefef;
  font-weight: 400;
  text-align: center;
}
.version-tips {
  font-size: 10px;
  line-height: 1.8;
  color: #7f7f7f;
}
</style>
